import gql from 'graphql-tag';

export const MOCK_ETF_DAYS_PREMIUM = {
    exchangeTradedFund: {
        name: 'T. Rowe Price Blue Chip Growth ETF',
        inceptionDate: '2020-08-04T04:00:00Z',
        premiumDiscount: {
            asOfDate: '2022-02-04T00:00:00Z',
            previousYear: '2020',
            daysTradedAtPremiumInPreviousYear: '89',
            daysTradedAtDiscountInPreviousYear: '45',
            currentYear: '2021',
            daysTradedAtPremiumInCurrentYearQ1: '66',
            daysTradedAtPremiumInCurrentYearQ2: '59',
            daysTradedAtPremiumInCurrentYearQ3: '70',
            daysTradedAtPremiumInCurrentYearQ4: '58',
            daysTradedAtDiscountInCurrentYearQ1: '13',
            daysTradedAtDiscountInCurrentYearQ2: '20',
            daysTradedAtDiscountInCurrentYearQ3: '13',
            daysTradedAtDiscountInCurrentYearQ4: '16',
            premiumDiscountData: [
                {
                    asOfDate: '2021-01-01T00:00:00Z',
                    premiumDiscountValueBPS: 7.125,
                    __typename: 'ETFPremiumDiscountData'
                },
                {
                    asOfDate: '2021-01-02T00:00:00Z',
                    premiumDiscountValueBPS: 7.125,
                    __typename: 'ETFPremiumDiscountData'
                },
                {
                    asOfDate: '2021-01-03T00:00:00Z',
                    premiumDiscountValueBPS: 7.125,
                    __typename: 'ETFPremiumDiscountData'
                },
                {
                    asOfDate: '2021-01-04T00:00:00Z',
                    premiumDiscountValueBPS: 3.6232,
                    __typename: 'ETFPremiumDiscountData'
                },
                {
                    asOfDate: '2021-01-05T00:00:00Z',
                    premiumDiscountValueBPS: 3.5958,
                    __typename: 'ETFPremiumDiscountData'
                },
                {
                    asOfDate: '2021-01-06T00:00:00Z',
                    premiumDiscountValueBPS: 0,
                    __typename: 'ETFPremiumDiscountData'
                }
            ],
            __typename: 'ETFPremiumDiscount'
        },
        __typename: 'ExchangeTradedFund'
    }
};

export const ETF_DAYS_PREMIUM = gql`
    query ETFPremiumDays($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            name
            shortName
            inceptionDate
            premiumDiscount {
                asOfDate
                previousYear
                daysTradedAtPremiumInPreviousYear
                daysTradedAtDiscountInPreviousYear
                currentYear
                daysTradedAtPremiumInCurrentYearQ1
                daysTradedAtPremiumInCurrentYearQ2
                daysTradedAtPremiumInCurrentYearQ3
                daysTradedAtPremiumInCurrentYearQ4
                daysTradedAtDiscountInCurrentYearQ1
                daysTradedAtDiscountInCurrentYearQ2
                daysTradedAtDiscountInCurrentYearQ3
                daysTradedAtDiscountInCurrentYearQ4
                premiumDiscountData {
                    asOfDate
                    premiumDiscountValueBPS
                }
            }
        }
    }
`;
